<style lang="scss" scoped>
.header {
  background-color: $c-white;
  //border: 1px solid $c-dark-grey !important;
  color: $c-blue !important;
  font-weight: 700 !important;
  text-align: left !important;
  padding: 15px 20px;
  position: relative;
  transition: all 200ms ease;
  margin-bottom: 7px;
  svg {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    fill: $c-blue;
    transition: all 200ms ease;
  }
  &.isOpen {
    svg {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
}
.collapse {
  background-color: $c-white;
  transition: all 200ms ease !important;
}

.empty {
  padding: 15px;
  text-align: center;
}

.skilltable {
  border: 1px solid $c-dark-grey;
}
</style>

<template>
  <div class="accordion">
    <div
      class="header"
      :class="{ isOpen }"
      role="button"
      data-bs-toggle="collapse"
      :data-bs-target="`#${id}`"
      aria-expanded="false"
      :aria-controls="id"
      @click="headerClick"
    >
      {{ title }} <Icon :path="mdiPlus" :height="30" :width="30" v-if="skills.length > 0" />
    </div>
    <div class="collapse" :id="id" :class="{ show: isOpen }" v-if="skills.length > 0">
      <SkillTable :name="name" :skills="skills" :type="type" :unit="unit" :title="title" />
    </div>
    <div class="collapse show empty" v-else>Keine Skills in dieser Kategorie</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, ref } from 'vue';
import { mdiPlus } from '@mdi/js';
import { Emitter } from 'mitt';

export default defineComponent({
  props: {
    skills: { type: Object, required: true },
    title: { type: String, required: true },
    type: { type: String, default: 'personal' },
    unit: { type: Number },
    group: { type: String, default: 'personal' },
    name: { type: String, default: '' },
  },
  setup(props) {
    const id = '_' + Math.random().toString(36).slice(-2);
    const isOpen = ref(localStorage.getItem(`${props.group}-tableopen`) == 'open' || false);
    const mitt = inject('emitter') as Emitter<{ open: string }>;

    const headerClick = () => {
      isOpen.value = !isOpen.value;
      localStorage.setItem(`${props.group}-tableopen`, isOpen.value ? 'open' : 'closed');
    };

    mitt.on('open', (group: string) => {
      if (group == props.group) {
        isOpen.value = true;
        localStorage.setItem(`${props.group}-tableopen`, isOpen.value ? 'open' : 'closed');
      }
    });

    return {
      id,
      isOpen,
      headerClick,
      mdiPlus,
    };
  },
});
</script>
